import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TasksIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" /></svg>;

const TasksPage = () => {
    return (
        <div className="pb-20 min-h-full bg-[var(--bg-main)] flex flex-col font-sans selection:bg-[var(--accent-primary)]/20">
            <header className="px-8 py-10 md:py-14 max-w-7xl mx-auto w-full flex justify-between items-end">
                <div className="space-y-1">
                    <h1 className="text-4xl font-light text-[var(--text-main)] tracking-tighter">Tasks</h1>
                    <p className="text-sm text-[var(--text-muted)] font-medium">Automate your workflows and pipelines.</p>
                </div>
            </header>

            <div className="px-8 max-w-7xl mx-auto w-full flex-1">
                <AnimatePresence mode="wait">
                    <motion.div
                        key="empty-state"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        className="flex flex-col items-center justify-center py-32 text-center"
                    >
                        <div className="w-24 h-24 bg-[var(--bg-tertiary)]/30 backdrop-blur-md rounded-3xl flex items-center justify-center mb-6 border border-[var(--border-subtle)] shadow-2xl relative group">
                            <div className="absolute inset-0 bg-gradient-to-tr from-[var(--accent-primary)]/10 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity" />
                            <TasksIcon className="w-10 h-10 text-[var(--text-dim)]" />
                        </div>
                        <h2 className="text-xl font-semibold text-[var(--text-main)] mb-2 tracking-tight">Coming Soon</h2>
                        <p className="text-sm text-[var(--text-muted)] max-w-xs leading-relaxed">
                            Automate your workflows and pipelines. This feature is currently under construction.
                        </p>
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};

export default TasksPage;
